import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import Select from 'components/select';
import HelpImg from 'pages/provisioning/_components/helpImg';
import { orderPayload } from 'pages/provisioning/virtual-service/store';

const BusinessCategory = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(orderPayload);
    const [options, setOptions] = React.useState([]);
    const businessCategoryApi = useMutation(() => axios.get(endPoints.aws.lookups.awsBusinessCategory));

    const setBusinessCategory = (businessCategory) => {
        setOrder({
            ...order,
            businessCategory,
        });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (businessCategory) => options.find((option) => businessCategory === option.value);

    const handleOnSelectChange = (selected) => {
        setBusinessCategory(selected.value);
        setIsTouched(false);
    };

    React.useEffect(() => {
        if (businessCategoryApi?.isSuccess && businessCategoryApi?.data?.data) {
            const opts = businessCategoryApi?.data?.data?.map((category) => ({
                label: category,
                value: category,
            }));
            setOptions(opts);
        }
    }, [businessCategoryApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.businessCategory) {
            setOrder({ ...order, businessCategory: options?.[0].value });
        }
        if (options && options?.length && order?.businessCategory) {
            const businessCategory = isExistsInOptions(order?.businessCategory);
            if (businessCategory) {
                setOrder({ ...order, businessCategory: businessCategory?.value });
            }
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        businessCategoryApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!order?.businessCategory && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.businessCategory, order?.isTouched]);

    return (
        <Box display="flex" gap={1}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={1} sx={{ width: '100%' }}>
                <Select
                    dataTestId="business-category-autocomplete"
                    key="businessCategory"
                    label="Business Category *"
                    value={order?.businessCategory || null}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value)}
                    disabled={businessCategoryApi.isLoading}
                    isLoading={businessCategoryApi.isLoading}
                    isRequired={isTouched}
                />
            </Box>
            <HelpImg
                title={
                    <Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>Business Category Options:</span>
                                </Typography>
                                <Typography>• make = Manufacturing</Typography>
                                <Typography>• move = Product Movement</Typography>
                                <Typography>• sell = Selling Production</Typography>
                                <Typography>• all = Including All Options</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                }
            />
        </Box>
    );
};

export default React.memo(BusinessCategory);
